import * as swcHelpers from '@swc/helpers';
import { acceptJson, postJson } from '../shared.js';
import { unwrapCartResponse } from './shared.js';

const replicateCart = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        return unwrapCartResponse((yield fetch(`${apiUrl}/replicate`, {
            method: 'POST',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson),
            body: JSON.stringify({
                reference: request.reference
            })
        })));
    });
    return function replicateCart(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { replicateCart };
//# sourceMappingURL=cart.js.map
